import { createFileRoute } from '@tanstack/react-router';
import { ProfileSettingsPage } from '../../components/settings/settings-shell.js';

export const Route = createFileRoute('/settings/profile')({
  component: ProfileSettingsPage,
});
